
import { useTranslation } from 'react-i18next'
export const FuncFormattedMessage = (id: string, defaultMessage: string) => {
    const { t, i18n } = useTranslation()
    return i18n.exists(id) ? t(id).toString() : defaultMessage
}